module.exports = __webpack_public_path__ + "img/wave-lines.c6105da.svg";